import { Greige } from '../greige/greige';
import { Translation } from '../translations';

export interface EntityKey {
  reference: string;
  number: string;
  entityDefinitionCode: number;
}

export interface Roll {
  createdDate?: string;
  createdBy?: string;
  modifiedBy?: string;
  modifiedDate?: string;
  id?: string;
  number?: string;
  reasonOfCreation?: number;
  status: number;
  rollQuality: number;
  knittingOrderNumber: string;
  knittingOrderReference: string;
  itemCode: string;
  expectedFabricCode?: string;
  originalFabricCode?: string;
  assetId: string | undefined;
  yarnLotId?: string;
  greige?: Greige;
  plannedWeight: number;
  stationTimeStamps?: stationTimeStamps[];
  isActive?: boolean;
  lastPrintedDate?: Date;
  knittingOrderVariantCode?: string;
  netQuantity?: number;
  grossQuantity?: number;
  overrideWeight?: number;
  finalWeight?: stationTimeStamps;
  finalWeightOrder?: number;
  finalLengthInYards?: number;
  finalLabelPrints?: FinalLabelPrintingInfo[];
  productionCardReference?: string;
  // currentlyLinkedToProductionCardKey?: NumberedDocumentKey;
  workOrderReference?: string;
  colorReference?: string;
  currentLocationCode?: string;
  finalQC?: FinalQc;
  rollCategory?: RollCategory;
  highestRollNumber?: string;
  currentlyLinkedToProductionCardKey?: EntityKey;
  linkedToPCHistory?: { status: string; user: unknown; date: string }[];
}

export interface FinalQc {
  isApproved: boolean;
  comments?: string;
  date?: Date;
  approvedBy?: string;
  finalGsm?: number;
  finalWidth?: number;
  category?: number;
  hold?: boolean;
}

export interface FinalQCUpdateCommand {
  rollNumber: string;
  isApproved: boolean;
  comments?: string;
  finalGsm?: number;
  finalWidth?: number;
  finalLengthInYards?: number;
  rollCategory?: number | null;
  hold?: boolean;
}

export interface stationTimeStamps {
  stationAssetId: string;
  timeStamp: Date;
  weightInLbs: number;
  weightType?: WeightType;
  locationCode?: string;
  username?: string;
}

export enum WeightType {
  Production,
  QualityControl,
  Final,
  Adjustment,
  ParentSplit,
  ChildSplit,
}

export const WeightTypeLabelKeys: Record<WeightType, string> = {
  [WeightType.Production]: 'Stations_Weight_Station_Detail_WeightType_Production',
  [WeightType.QualityControl]: 'Stations_Weight_Station_Detail_WeightType_QualityControl',
  [WeightType.Final]: 'Stations_Weight_Station_Detail_WeightType_Final',
  [WeightType.Adjustment]: 'Stations_Weight_Station_Detail_WeightType_Adjustment',
  [WeightType.ParentSplit]: 'Stations_Weight_Station_Detail_WeightType_ParentSplit',
  [WeightType.ChildSplit]: 'Stations_Weight_Station_Detail_WeightType_ChildSplit',
};

export interface FinalLabelPrintingInfo {
  date: Date;
  printedBy: string;
}

export enum RollCategory {
  LeftOverAssignable = 0,
  LeftOverNotAssignable = 1,
  FirstQuality = 2,
  BGrade = 3,
  LargeBGrade = 4,
}

export interface RollSearchCommand {
  rollNumbers?: string[];
}

export interface NumberedDocumentKey {
  reference?: string;
  number?: string;
}

export interface CodedDocumentKey {
  code: number;
  name: string;
}

export interface RollSearchResultItem {
  number: string;
  status?: number;
  category?: number;
  quality?: number;
  currentProductionCard?: NumberedDocumentKey;
  knittingOrder?: NumberedDocumentKey;
  productionCard?: NumberedDocumentKey;
  workOrder?: NumberedDocumentKey;
  colorName?: string;
  labDipNumber?: string;
  currentLocationCode: string;
  currentLocationName: Translation;
  shipped: boolean;
  shippedDate?: string;
  dispatchInstruction?: NumberedDocumentKey;
  expectedFabricCode: string;
  expectedFabricDescription: string;
  itemCode: string;
  itemName: Translation;
  lastRecordedWeightLbs: number;
  finalWeightLbs: number;
  finalGSM: number;
  finalWidth: number;
}
